<div
  class="bg-input-background box-border flex w-full text-base"
  [class.cursor-not-allowed]="ngControl.control!.disabled"
  [class.opacity-60]="ngControl.control!.disabled">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <input
      [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
      class="border-input rounded-input peer p-input text-standard-text focus:border-input-focus w-full bg-transparent placeholder-transparent focus:ring-0 disabled:pointer-events-none"
      [class.border-input-error]="hasError"
      [class.border-input-ring]="!hasError"
      [id]="id()"
      [placeholder]="label() ?? ''"
      [type]="inputType()" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [class.-top-2!]="placeholder()"
      [class.text-sm!]="placeholder()"
      [class.text-input-error]="hasError"
      [class.text-standard-text]="!hasError"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
    @if (placeholder() && !ngControl.control!.value && !isFocused()) {
      <span
        [attr.data-testid]="id() | appendTestId: 'placeholder'"
        [attr.aria-label]="placeholder()"
        class="text-input-label/60 pointer-events-none absolute top-3.5 right-4 left-4 max-h-6 w-fit overflow-hidden bg-inherit">
        {{ placeholder() }}
      </span>
    }
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
